package com.essntl.features.proposal.ui.addeditproposal.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.key.isCtrlPressed
import androidx.compose.ui.input.key.isMetaPressed
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.mohamedrejeb.compose.dnd.DragAndDropState
import com.mohamedrejeb.compose.dnd.drag.DraggableItem
import com.mohamedrejeb.compose.dnd.drop.dropTarget
import com.essntl.components.multiselect.MultiSelectContainer
import com.essntl.components.multiselect.rememberMultiSelectState
import com.essntl.components.multiselect.selectableItem
import core.dateformat.utils.formatNumber
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalEvent
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalNavigation
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalState
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.key.LocalKeyboardState
import com.essntl.uikit.rememberContains
import com.essntl.uikit.rememberFind
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.calf.core.LocalPlatformContext
import com.mohamedrejeb.compose.dnd.drag.DropStrategy
import kotlinx.datetime.LocalDate
import kotlin.collections.orEmpty
import kotlin.collections.toSet

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun JourneyDayRow(
    state: AddEditProposalState,
    onEvent: (AddEditProposalEvent) -> Unit,
    onNavigation: (AddEditProposalNavigation) -> Unit,
    dragAndDropState: DragAndDropState<Pair<ServiceModel, ProposalServiceModel>>,
    index: Int,
    numberOfDays: Int,
    localDate: LocalDate,
    proposalServiceList: List<ProposalServiceModel>,
    isTotalOnlyProposal: Boolean,
    modifier: Modifier = Modifier,
) {
    val keyboardState = LocalKeyboardState.current
    val multiSelectState = rememberMultiSelectState()
    val esColorScheme = MaterialTheme.esColorScheme
    val context = LocalPlatformContext.current

    Row(
        horizontalArrangement = Arrangement.spacedBy(1.spacing),
        verticalAlignment = Alignment.Top,
        modifier = modifier,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
        ) {
            Text(
                text = "${formatNumber(localDate.monthNumber)}.${formatNumber(localDate.dayOfMonth)}",
                color = MaterialTheme.esColorScheme.primary,
                style = MaterialTheme.esTypography.p2Regular14,
            )

            Text(
                text = localDate.dayOfWeek.name.substring(0, 3),
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p2Regular14,
            )

            Spacer(modifier = Modifier.height(1.spacing))

            if (index != numberOfDays - 1) {
                Box(
                    modifier =
                        Modifier
                            .height(40.dp)
                            .width(1.dp)
                            .background(color = MaterialTheme.esColorScheme.borderPrimary),
                )
            }
        }

        LaunchedEffect(multiSelectState.isSelecting, multiSelectState.selectedItemsIds) {
            if (!state.isEnabled) return@LaunchedEffect

            if (multiSelectState.isSelecting) {
                val pressedKey = keyboardState.pressedKey
                val isCtrlPressed =
                    pressedKey != null &&
                        (
                            pressedKey.isCtrlPressed ||
                                pressedKey.isMetaPressed
                            )

                onEvent(
                    AddEditProposalEvent.ProposalServiceGrouped(
                        multiSelectState.selectedItemsIds,
                        localDate.toString(),
                        isCtrlPressed,
                    ),
                )
            }
        }

        MultiSelectContainer(
//            dragAndDropState = dragAndDropState,
            state = multiSelectState,
            drawSelection = { topLeft, size ->
                drawRect(
                    color = esColorScheme.primary,
                    topLeft = topLeft,
                    size = size,
                    alpha = .2f,
                )

                drawRect(
                    color = esColorScheme.primary,
                    topLeft = topLeft,
                    size = size,
                    style =
                        Stroke(
                            width = 2.dp.toPx(),
                        ),
                )
            },
            enabled = state.isEnabled && !state.isLoading && !state.addEditProposal.isLoading,
            modifier =
                Modifier
                    .border(
                        width = 1.dp,
                        color = MaterialTheme.esColorScheme.borderPrimary,
                        shape = RoundedCornerShape(2.spacing),
                    )
                    .clip(RoundedCornerShape(2.spacing))
                    .background(MaterialTheme.esColorScheme.bgSecondary)
                    .fillMaxWidth()
                    .dropTarget(
                        key = localDate.toString(),
                        state = dragAndDropState,
                        onDrop = { state ->
                            val (service, proposalService) = state.data
                            onEvent(
                                AddEditProposalEvent.AddProposalService(
                                    service = service,
                                    proposalService = proposalService,
                                    date = localDate.toString(),
                                    index = -1,
                                    dropped = true,
                                    context = context,
                                ),
                            )
                        },
                        onDragEnter = { state ->
                            println("onDragEnter Container")
                            val (service, proposalService) = state.data
                            onEvent(
                                AddEditProposalEvent.AddProposalService(
                                    service = service,
                                    proposalService = proposalService,
                                    date = localDate.toString(),
                                    index = -1,
                                    dropped = false,
                                    context = context,
                                ),
                            )
                        },
                        onDragExit = { state ->
                            println("onDragExit Container")
                            val (_, proposalService) = state.data
                        },
                    ),
        ) {
            val constants = EsConstants.JourneyDayRow
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(constants.CardHorizontalSpacing),
                verticalArrangement = Arrangement.spacedBy(constants.CardPadding),
                modifier =
                    Modifier
                        .fillMaxWidth()
                        .padding(constants.CardPadding),
            ) {
                proposalServiceList.forEach { proposalService ->
                    val category = rememberFind(
                        state.getAllCategory.data.orEmpty(),
                        proposalService.service.category,
                    ) { category -> category.id }

                    val isSelected = state.selectedProposalService.value?.id == proposalService.id

                    val prices = rememberContains(
                        state.getAllProposalServicesPrices.data.orEmpty(),
                        setOf(proposalService.id),
                    ) { p -> p.proposalService.id }

                    key("${proposalService.id}-${proposalService.index}") {
                        DraggableItem(
                            key = proposalService.id,
                            state = dragAndDropState,
                            data = remember(
                                proposalService,
                                proposalService.service,
                            ) { proposalService.service to proposalService },
                            enabled = state.isEnabled && !state.isLoading && !state.addEditProposal.isLoading,
                            modifier = Modifier
                                .dropTarget(
                                    key = proposalService.id,
                                    state = dragAndDropState,
                                    zIndex = 1f,
                                    onDrop = { state ->
                                        val (service, newProposalService) = state.data
                                        onEvent(
                                            AddEditProposalEvent.AddProposalService(
                                                service = service,
                                                proposalService = newProposalService,
                                                date = localDate.toString(),
                                                index = proposalService.index,
                                                dropped = true,
                                                context = context,
                                            ),
                                        )
                                    },
                                    onDragEnter = { state ->
                                        println("onDragEnter Draggable")
                                        val (service, newProposalService) = state.data
                                        onEvent(
                                            AddEditProposalEvent.AddProposalService(
                                                service = service,
                                                proposalService = newProposalService,
                                                date = localDate.toString(),
                                                index = proposalService.index,
                                                dropped = false,
                                                context = context,
                                            ),
                                        )
                                    },
                                    onDragExit = { state ->
                                        println("onDragExit Draggable")
                                        val (_, ps) = state.data
                                    },
                                ),
                        ) {
                            EsTooltip(
                                text = proposalService.service.title,
                            ) {
                                ProposalServiceCard(
                                    service = proposalService.service,
                                    price = proposalService.price,
                                    loading = state.updateProposalServicesPrices.contains(proposalService.id),
                                    proposalServicePrices = prices,
                                    dynamicPriceEnabled = proposalService.dynamicPriceEnabled ?: false,
                                    priceCurrency = proposalService.priceCurrency?.symbol,
                                    category = category,
                                    isTotalOnlyProposal = isTotalOnlyProposal,
                                    isPaid = proposalService.paid == true,
                                    isEnabled = state.isEnabled,
                                    hideOnProposal = proposalService.hideOnProposal == true,
                                    isSetAsPaidEnabled = !state.proposal.value.itineraryId.isNullOrBlank(),
                                    isInGroupSelection = proposalService.grouped == true,
                                    isSelected = isSelected,
                                    onSetPrice = {
                                        onNavigation(AddEditProposalNavigation.SetPrice(proposalService))
                                    },
                                    onSelect = {
                                        onEvent(AddEditProposalEvent.UpdateSelectedProposalService(proposalService))
                                    },
                                    onDoubleClick = {
                                        onNavigation(
                                            AddEditProposalNavigation.EditService(
                                                proposalService.service,
                                                false,
                                            ),
                                        )
                                    },
                                    onAddToGroup = {
                                        onEvent(AddEditProposalEvent.AddProposalServiceToGroup(proposalService.id))
                                    },
                                    onDuplicateProposalService = {
                                        onEvent(
                                            AddEditProposalEvent.AddProposalService(
                                                service = proposalService.service,
                                                proposalService =
                                                    proposalService.copy(
                                                        id = "drag",
                                                        proposalId = null,
                                                    ),
                                                date = localDate.toString(),
                                                index = proposalService.index + 1,
                                                dropped = true,
                                                context = context,
                                            ),
                                        )
                                    },
                                    onDeleteProposalService = {
                                        onEvent(
                                            AddEditProposalEvent.DeleteProposalService(
                                                date = proposalService.startDate,
                                                index = proposalService.index,
                                            ),
                                        )
                                        onNavigation(AddEditProposalNavigation.ClosePanel)
                                    },
                                    onMarkPaid = {
                                        onEvent(AddEditProposalEvent.MarkProposalServiceAsPaid(proposalService))
                                    },
                                    onNavigateToItinerary = {
                                        state.proposal.value.itineraryId?.let {
                                            onNavigation(
                                                AddEditProposalNavigation.NavigateToItinerary(itineraryId = it),
                                            )
                                        }
                                    },
                                    onHideOnProposal = {
                                        onEvent(AddEditProposalEvent.HideServiceOnProposal(proposalService))
                                    },
                                    modifier = Modifier
                                        .selectableItem(
                                            id = proposalService.id,
                                            state = multiSelectState,
                                        )
                                        .graphicsLayer {
                                            alpha = if (proposalService.id == "drag" || isDragging) 0f else 1f
                                        }
                                )
                            }
                        }
                    }
                }

                Box(
                    modifier =
                        Modifier
                            .padding(
                                horizontal = 13.dp,
                                vertical = 1.spacing,
                            )
                            .height(48.dp),
                ) {
                    EsLargeIcon(
                        res = EsIcons.Add,
                        tint = MaterialTheme.esColorScheme.iconSecondary,
                        modifier = Modifier
                            .align(Alignment.Center)
                            .clip(CircleShape)
                            .pointerHoverIcon(PointerIcon.Hand)
                            .clickable(
                                enabled = state.isEnabled,
                                onClick = {
                                    onEvent(AddEditProposalEvent.SelectProposalServiceDate(localDate.toString()))
                                },
                            ),
                    )
                }
            }
        }
    }
}
